module.exports = __webpack_public_path__ + "img/trial1-4.2183f66f.png";